export enum ProspectStatus {    
    InProcess = 1,
    ClosedWon = 2,
    ClosedLost = 3
}